import { PolygonFilter } from "../../../../models/filter";

/**
 * True when the incoming map extent's coordinates already match the current
 * polygon filter's, so a map-extent sync can be skipped as a no-op.
 *
 * Shared by the well and facility filter reducers (filterWellsFromMapExtent)
 * and the extent-sync effects in useFilterWatcher so all four run the exact
 * same comparison. A missing polygon filter compares as null — never equal to
 * a real coordinate array — and only coordinates are compared, not id/source.
 */
export const polygonCoordsEqual = (
  polygon: PolygonFilter | null | undefined,
  extent: GeoJSON.Polygon
): boolean => {
  const existingJson = polygon ? JSON.stringify(polygon.coordinates) : null;
  return existingJson === JSON.stringify(extent.coordinates);
};
